var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredlagaj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1687",
    "data-name": "Group 1687",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 99.134,
    viewBox: "0 0 65 99.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 65,
    height: 99.134,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 65,
    height: 99.134,
    rx: 10,
    transform: "translate(0)",
    fill: "#587be1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2904",
    "data-name": "Path 2904",
    d: "M30.925,207.963l-8.088,22.455H39.013c.013-.027,4.788-28.078,3.609-31.971-1.2-3.967-5.284-16.489-5.325-16.615a.294.294,0,0,0-.339-.2c-.094.019-2.315.5-2.472,2.362-.116,1.382-.06,6.24-.034,8.013-1.223-1.057-4.425-4.014-5.876-7.178a.293.293,0,0,0-.39-.145.288.288,0,0,0-.158.2.3.3,0,0,0-.112-.035c-.008,0-.014,0-.022,0,.258-.413.564-.89.9-1.385a3.7,3.7,0,0,0,.745-2.951,2.965,2.965,0,0,0-1.343-1.775.248.248,0,0,0-.027-.008l.094-.115c1.826-2.2-.352-5.385-.446-5.52a.3.3,0,0,0-.478-.008l-2.095,2.8c-.065-.79-.338-3.654-.918-4.558-.662-1.031-2.784-1.787-2.873-1.82a.295.295,0,0,0-.392.276l-.037,11.61a.284.284,0,0,0,.023.1l-1.375,1.835a.3.3,0,0,0-.057.212s1.594,12.913,1.629,12.955Z",
    transform: "translate(-15.188 -131.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2905",
    "data-name": "Path 2905",
    d: "M24.454,196.221l-4.3,5.741-1.372,1.832",
    transform: "translate(-14.548 -151.989)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M22.056,219.469c1.547-2.075,6.05-8.09,7.565-9.811",
    transform: "translate(-17.084 -162.396)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M32.878,241.552l5.509-5.434s1.437,2,.842,3.406a22.909,22.909,0,0,1-2.993,4.073l.829,3.056a11.043,11.043,0,0,1,6.721,4.142",
    transform: "translate(-25.467 -182.892)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M178.7,207.963l8.088,22.455H170.616c-.013-.027-4.788-28.078-3.609-31.971,1.2-3.967,5.284-16.489,5.325-16.615a.294.294,0,0,1,.339-.2c.094.019,2.315.5,2.472,2.362.116,1.382.06,6.24.034,8.013,1.223-1.057,4.425-4.014,5.876-7.178a.293.293,0,0,1,.39-.145.288.288,0,0,1,.158.2.3.3,0,0,1,.112-.035c.008,0,.014,0,.022,0-.258-.413-.564-.89-.9-1.385a3.7,3.7,0,0,1-.745-2.951,2.965,2.965,0,0,1,1.343-1.775.247.247,0,0,1,.027-.008l-.094-.115c-1.826-2.2.352-5.385.446-5.52a.3.3,0,0,1,.478-.008l2.095,2.8c.065-.79.338-3.654.918-4.558.662-1.031,2.784-1.787,2.873-1.82a.295.295,0,0,1,.392.276l.037,11.61a.284.284,0,0,1-.023.1l1.375,1.835a.3.3,0,0,1,.057.212s-1.594,12.913-1.629,12.955Z",
    transform: "translate(-129.215 -131.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M244.549,196.221l4.3,5.741,1.372,1.832",
    transform: "translate(-189.422 -151.989)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2910",
    "data-name": "Path 2910",
    d: "M240.445,219.469c-1.547-2.075-6.05-8.09-7.565-9.811",
    transform: "translate(-180.384 -162.396)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M218.133,241.552l-5.509-5.434s-1.437,2-.842,3.406a22.908,22.908,0,0,0,2.993,4.073l-.829,3.056a11.043,11.043,0,0,0-6.721,4.142",
    transform: "translate(-160.511 -182.892)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M75.01,62.494A15.716,15.716,0,0,1,94.68,47.018a15.271,15.271,0,0,1,10.966,10.475,15.787,15.787,0,0,1-6.922,18.231l.095,6.05-15.668.247-.095-6.05A15.71,15.71,0,0,1,75.01,62.494",
    transform: "translate(-58.1 -36.037)",
    fill: "#fccc42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M119.691,106.137s-.33-14.477.933-18.7c.45-1.506,3.379-5.716,5.154-3.61s-5.461,9.578-9.317,5.084c-2.315-2.7-3.716-11.577-.573-10.939,1.875.381,3.849,10.786.226,12.13-4.838,1.794-7.451-2.8-7.661-4.333s5.222,1.279,5.733,6.695.232,13.989.232,13.989",
    transform: "translate(-84 -60.37)",
    fill: "none",
    stroke: "#080717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2914",
    "data-name": "Path 2914",
    d: "M114.344,214.383l9.6-.149a3.033,3.033,0,0,0,2.985-3.08l-.131-8.261-15.667.244.131,8.263a3.033,3.033,0,0,0,3.079,2.984",
    transform: "translate(-86.082 -157.156)",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 17.153,
    y2: 0.267,
    transform: "translate(24.149 49.567)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 17.153,
    y2: 0.267,
    transform: "translate(24.149 46.413)",
    fill: "none",
    stroke: "#080717",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredlagaj);
export default __webpack_public_path__ + "static/media/predlagaj.577ab334b35ed7da5489f0dacf9feab7.svg";
export { ForwardRef as ReactComponent };